var React = require('react');

function ToiletInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"cx":"44","cy":"10","r":"5","key":0}),React.createElement("path",{"d":"M42.333 19h3.334a2 2 0 0 1 1.846 1.23L57 43H31l9.487-22.77A2 2 0 0 1 42.333 19zm.327 40h2.68a2 2 0 0 0 1.966-1.631L50 43H38l2.694 14.369A2 2 0 0 0 42.66 59z","key":1}),React.createElement("circle",{"cx":"16","cy":"10","r":"5","key":2}),React.createElement("path",{"d":"M10.81 19h10.38a2 2 0 0 1 1.99 1.801L25 39H7l1.82-18.199A2 2 0 0 1 10.81 19zM13 59h6a2 2 0 0 0 2-2V39H11v18a2 2 0 0 0 2 2z","key":3})]));
}

ToiletInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ToiletInline;

ToiletInline.default = ToiletInline;
